import { render, staticRenderFns } from "./Mydetails.vue?vue&type=template&id=977cf0a0&scoped=true&"
import script from "./Mydetails.vue?vue&type=script&lang=js&"
export * from "./Mydetails.vue?vue&type=script&lang=js&"
import style0 from "./Mydetails.vue?vue&type=style&index=0&id=977cf0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977cf0a0",
  null
  
)

export default component.exports